import { render, staticRenderFns } from "./BookCourseDialog.vue?vue&type=template&id=a38b9882&scoped=true"
import script from "./BookCourseDialog.vue?vue&type=script&lang=js"
export * from "./BookCourseDialog.vue?vue&type=script&lang=js"
import style0 from "./BookCourseDialog.vue?vue&type=style&index=0&id=a38b9882&prod&lang=scss&scoped=true"
import style1 from "./BookCourseDialog.vue?vue&type=style&index=1&id=a38b9882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38b9882",
  null
  
)

export default component.exports